import { PresedensTagType } from './../../../models/presedensTagType';
import RequestTreeService from '../requestTreeService';

export default class PresedensTagTypeService extends RequestTreeService<PresedensTagType,'presedensTagType'> {}
